import { Pipe, PipeTransform } from '@angular/core';
import { InternalRoute } from "angular-engine/model/api.model";

@Pipe({name: 'route'})
export class RoutePipe implements PipeTransform {
    transform(value: InternalRoute[], preferredType: string): string {
        if(value == null || value.length == 0){
            return null;
        }

        if(preferredType == null || preferredType.length == 0){
            preferredType = "details_route";
        }

        let preferredRoute = value.filter(function(e){
            return e.route_type == preferredType;
        });

        if(preferredRoute.length > 0){
            return preferredRoute[0].route;
        }

        return value[0].route;
    }
}



// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-pipe/route.pipe.ts